import React from 'react';
import { IconStroke, IconProps } from './IconTemplate';

import { ReactComponent as Icon } from '@assets/icons/video-camera.svg';

export default function VideoCameraIcon(props: IconProps) {
  return <IconStroke icon={Icon} {...props} />;
}
